export enum CheckoutState {
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  DISABLED = 'DISABLED',
  OPEN = 'OPEN',
  PENDING = 'PENDING',
}
